import React, {Component, ReactNode} from 'react';
import FormicaInput from '../../custom/FormicaInput';
import FormicaLabel from '../../custom/FormicaLabel';
import AnimatedButton from '../../custom/AnimatedButton';
import LanguageUtil from '../../../util/LanguageUtil';
import RoleHelper from '../../../RoleHelper';
import ComponentName from '../../../constant/ComponentName';

interface Props {
  name: string;
  description: string;
  loading: boolean;
  onChangeName: (value: string) => void;
  onChangeDescription: (value: string) => void;
  onAdd: () => void;
}

class CustomListCreatorComponent extends Component<Props> {
  public render(): ReactNode {
    const {name, description, loading, onChangeName, onChangeDescription, onAdd} = this.props;
    const canEdit: boolean = RoleHelper.canEdit(ComponentName.CUSTOM_LIST);
    const placeholder: string = LanguageUtil.get({id: 'common.input.placeholder.default', defaultMessage: 'enter the required information'});

    return (
      <div className={'flex flex-col w-full h-full gap-y-5'}>
        <div className={'flex flex-col gap-y-1.5 w-full'}>
          <FormicaLabel label={LanguageUtil.get({id: 'common.label.name', defaultMessage: 'Name'})}/>
          <FormicaInput
            value={name}
            disabled={!canEdit || loading}
            onChange={(e) => onChangeName(e.currentTarget.value)}
            placeholder={placeholder}
            icon={'edit'}
          />
        </div>
        <div className={'flex flex-col gap-y-1.5 w-full'}>
          <FormicaLabel label={LanguageUtil.get({id: 'common.label.description', defaultMessage: 'Description'})}/>
          <FormicaInput
            value={description}
            disabled={!canEdit || loading}
            onChange={(e) => onChangeDescription(e.currentTarget.value)}
            placeholder={placeholder}
            icon={'edit'}
          />
        </div>
        <div className={'flex w-full items-center justify-end mt-auto'}>
          <AnimatedButton
            icon={'save'}
            text={LanguageUtil.get({id: 'common.button.save', defaultMessage: 'Save'})}
            customType={'outlined'}
            disabled={!canEdit || loading}
            loading={loading}
            onClick={onAdd}
          />
        </div>
      </div>
    );
  }
}

export default CustomListCreatorComponent;
